//
import Model from '@/models/Model'

/**
 * @description
 * This class describes a hr absence request.
 *
 * @class   HrAbsenceRequest (name)
 */
export default class HrAbsenceRequest extends Model {

    //
    static includes = [
        'hr_absence_request_type',
        'hr_absence_request_status',
        'hr_employee',
    ]

    /**
     * @description
     * { property_description }
     *
     * @type       {boolean}
     */
    get can_holiday_pdf() {
        return this.hr_absence_request_type_id === 1 || this.hr_absence_request_type_id === 2
    }

    /**
     * @description
     * { item_description }
     */
    mapHolidayPdf = this.showFile('download', 'pdf')

    /**
     * @description
     * { function_description }
     *
     * @return  {string}    { description_of_the_return_value }
     */
    resource() {
        return 'hr_absence_request'
    }

    /**
     * @description
     * Returns a holiday pdf representation of the object.
     *
     * @return  {<type>}    Holiday pdf representation of the object.
     */
    toHolidayPdf() {
        return this.pdf('holiday_pdf').then(this.mapHolidayPdf)
    }
}
